.root {
  position: relative;
  width: 100%;
}

.select {
  composes: field from '../field.module.css';
  width: 100%;
  height: 38px;
  padding: 0 36px 0 12px;
  appearance: none;
  cursor: pointer;
}

.chevron {
  position: absolute;
  right: 13px;
  top: 12px;
  color: var(--ink-3);
  pointer-events: none;
}
